<template>
  <!-- چطور استفاده کنیم
<advance-uploader :imagesProps="aaa" :imageFileIdsProps="bbb" @imagesFileIdsChange="e=>bbb=e" @imagesChange="e=>aaa=e"></advance-uploader>

data:{
    aaa:[],
    bbb:[]
}
نکته: برای ویرایش آی دی های عکس ها را در imageFileIdsProps قرار دهید
 -->
  <div>
    <v-row class="ma-0 image-background-box rounded">
      <v-btn
        :disabled="(singleFile && imagesProps.length >= 1) || disabledBtn"
        class="primary ma-0"
        style="width: 150px"
        @click="contentDialog = !contentDialog"
        >{{ title }}</v-btn
      >
    </v-row>
    <v-row v-if="images.length && !fileManager" class="m-3 border">
      <v-col
        justify="center"
        align="center"
        cols="12"
        md="2"
        v-for="(item, i) in images"
        :key="i"
      >
        <div class="custom-item">
          <span @click="removeImg(item)" class="custom-notify-badge">
            <v-icon color="white" small slot="badge"
              >mdi-delete-empty-outline</v-icon
            ></span
          >

          <img
            class="rounded primary lighten-2"
            :src="item.fileUrl"
            @click="openImage(item.fileUrl)"
            width="150"
          />
        </div>
      </v-col>
    </v-row>

    <v-dialog
      width="1000px"
      :fullscreen="$vuetify.breakpoint.mobile"
      transition="dialog-bottom-transition"
      class="upload-image-modal"
      persistent
      v-model="contentDialog"
    >
      <v-card>
        <v-card-text>
          <v-row class="pt-4 px-2">
            <v-col cols="12" md="4" class="d-flex justify-start">
              <h3>انتخاب عکس برای {{ cropTypeProp }}</h3>
            </v-col>
            <v-col cols="12" md="8">
              <v-row class="d-flex justify-end">
                <v-btn
                  small
                  :disabled="uploadLoading"
                  class="buttoncancel error ma-1"
                  @click="closeDialog()"
                >
                  انصراف
                </v-btn>

                <v-btn
                  small
                  :disabled="uploadLoading"
                  :loading="openLoading"
                  class="button primary ma-1"
                  @click="$refs.input.click()"
                >
                  <input
                    style="display: none"
                    ref="input"
                    type="file"
                    name="image"
                    accept="image/*"
                    @change="setImage"
                  />
                  {{ result ? 'تغییر عکس' : 'بارگذاری عکس' }}
                </v-btn>

                <v-btn
                  small
                  :loading="uploadLoading"
                  v-if="result"
                  class="button primary ma-1"
                  @click="sendImage(result)"
                >
                  ارسال عکس
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
          <v-divider style="margin-top: 20px"></v-divider>

          <v-row
            v-if="cropTypeProp != 'آپلود لوگو' && !$vuetify.breakpoint.mobile"
            class="px-2"
          >
            <v-col cols="12" md="8">
              <p>
                با استفاده از اسکرول ماوس عکس را داخل مربع سفید قراردهید و بعد
                با موس می توانید عکس را بسمت چپ یا راست جابجا کنید. برای چرخاندن
                عکس بصورت افقی یا عمودی از قسمت ابزار استفاده کنید .
              </p>
            </v-col>
          </v-row>

          <v-progress-linear
            v-if="uploadLoading"
            v-model="progressBarValue"
            color="primary"
            height="25"
          >
            <template v-slot:default="{ value }">
              <strong>{{ Math.ceil(value) }}%</strong>
            </template>
          </v-progress-linear>

          <div>
            <div class="row">
              <section class="col-12 col-md-9 cropper-area" id="cropperId">
                <div class="img-cropper">
                  <vue-cropper
                    @zoom="zoomHandler"
                    v-if="cropTypeProp != 'آپلود لوگو'"
                    class="cropper"
                    ref="cropper"
                    id="cropperSection"
                    dragMode="none"
                    :aspect-ratio="aspectRatio"
                    :src="imgSrc"
                    :aspectRatio="aspectRatio"
                    preview=".preview"
                  />
                  <img
                    v-else
                    :src="image && image.src ? image.src : ''"
                    width="100%"
                    height="100%"
                  />
                </div>
                <div v-if="cropTypeProp != 'آپلود لوگو' && result">
                  <v-btn
                    title="بزرگنمایی"
                    class="primary btn-sm text-white m-1"
                    small
                    @click.prevent="zoom(0.2)"
                  >
                    <v-icon color="white">mdi-magnify-plus-outline</v-icon>
                  </v-btn>
                  <v-btn
                    title="کوچک نمایی"
                    class="primary btn-sm text-white m-1"
                    small
                    @click.prevent="zoom(-0.2)"
                  >
                    <v-icon color="white">mdi-magnify-minus-outline</v-icon>
                  </v-btn>
                  <v-btn
                    title="حرکت به راست"
                    class="primary btn-sm text-white m-1"
                    small
                    @click.prevent="move(10, 0)"
                    ><v-icon color="white">mdi-arrow-right-bold </v-icon>
                  </v-btn>
                  <v-btn
                    title="حرکت به چپ"
                    class="primary btn-sm text-white m-1"
                    small
                    @click.prevent="move(-10, 0)"
                  >
                    <v-icon color="white">mdi-arrow-left-bold </v-icon>
                  </v-btn>

                  <v-btn
                    title="حرکت به بالا"
                    class="primary btn-sm text-white m-1"
                    small
                    @click.prevent="move(0, -10)"
                  >
                    <v-icon color="white">mdi-arrow-up-bold </v-icon>
                  </v-btn>
                  <v-btn
                    title="حرکت به پایین"
                    class="primary btn-sm text-white m-1"
                    small
                    @click.prevent="move(0, 10)"
                  >
                    <v-icon color="white">mdi-arrow-down-bold </v-icon>
                  </v-btn>
                  <v-btn
                    title="چرخش به راست"
                    class="primary btn-sm text-white m-1"
                    small
                    @click.prevent="rotate(90)"
                    ><v-icon color="white">mdi-reload</v-icon>
                  </v-btn>
                  <v-btn
                    title="چرخش به چپ"
                    class="primary btn-sm text-white m-1"
                    small
                    @click.prevent="rotate(-90)"
                  >
                    <v-icon color="white">mdi-restore</v-icon>
                  </v-btn>
                  <a
                    class="primary btn-sm text-white m-1"
                    ref="flipX"
                    small
                    @click.prevent="flipX"
                    ><v-icon color="white">mdi-axis-z-rotate-clockwise</v-icon>
                  </a>
                  <a
                    class="primary btn-sm text-white m-1"
                    ref="flipY"
                    small
                    @click.prevent="flipY"
                    ><v-icon color="white">mdi-axis-y-rotate-clockwise</v-icon>
                  </a>
                  <v-btn
                    title="Reset"
                    class="primary btn-sm text-white m-1"
                    small
                    @click.prevent="reset"
                    ><v-icon color="white">mdi-rotate-right</v-icon>
                  </v-btn>
                </div>
              </section>
              <section
                v-if="cropTypeProp != 'آپلود لوگو' && result"
                class="col-md-3 col-12 preview-area"
              >
                <p>پیش نمایش</p>
                <div class="preview"></div>
                <v-row
                  class="mt-5"
                  v-if="croppedSize && croppedWidth && croppedHeight"
                >
                  <!-- حجم: {{ croppedSize }} {{ message }}   -->
                </v-row>
                <v-row>
                  ابعاد تصویر : {{ croppedWidth }}*{{ croppedHeight }}
                </v-row>
              </section>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import axios from 'axios';
import Helper from '@/core/helpers';
import Swal from 'sweetalert2';
import { RepoFactory } from '@/baseRepository/Factory';
const filesRepository = () => RepoFactory.get('files');
function getMimeType(file, fallback = null) {
  const byteArray = new Uint8Array(file).subarray(0, 4);
  let header = '';
  for (let i = 0; i < byteArray.length; i++) {
    header += byteArray[i].toString(16);
  }
  switch (header) {
    case '89504e47':
      return 'image/png';
    case '47494638':
      return 'image/gif';
    case 'ffd8ffe0':
    case 'ffd8ffe1':
    case 'ffd8ffe2':
    case 'ffd8ffe3':
    case 'ffd8ffe8':
      return 'image/jpeg';
    default:
      return fallback;
  }
}
export default {
  components: {
    VueCropper,
  },
  props: {
    aspectRatio: {
      type: Number,
      default: 16 / 9,
    },
    title: {
      type: String,
      default: 'اضافه کردن عکس',
    },
    maxFileSize: {
      type: String,
      default: '1M',
      description: 'حداکثر سایز قابل آپلود فایل (exp: 100K , 1M)',
    },
    logoMaxFileSize: {
      type: String,
      default: '200K',
      description: 'حداکثر سایز قابل آپلود فایل (exp: 100K , 1M)',
    },
    imageFileIdsProps: {
      type: Array,
      default: () => [],
    },
    imagesProps: {
      type: Array,
      default: () => [],
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    disabledBtn: {
      type: Boolean,
      default: false,
    },
    singleFile: {
      type: Boolean,
      default: false,
    },
    sizeCheckPermission: {
      type: Boolean,
      default: false,
    },
    widthLimit: {
      type: Number,
      default: 1000,
    },
    heightLimit: {
      type: Number,
      default: 1000,
    },
    cropTypeProp: {
      type: String,
      default: 'آپلود',
    },
    stencilProps: {
      type: Object,
      default: () => ({
        handlers: {},
        movable: false,
        scalable: false,
      }),
    },
    stencilSize: {
      type: Boolean,
      default: true,
    },
    folder: {
      type: String,
      default: 'Public',
    },
    fileManager: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      message: '',
      img: '',
      imgWidth: 0,
      imgHeight: 0,
      setImageFlag: false,
      cropType: {
        width: 150,
        height: 150,
        type: 'پرتره',
        info: 'این عکس شما در صفحه اختصاصیتان میباشد . اندازه مناسب این عکس عرض 150 و طول 150 میباشد .',
      },
      cropTypeItems: [
        {
          width: 150,
          height: 150,
          type: 'پرتره',
          info: 'این عکس شما در صفحه اختصاصیتان میباشد . اندازه مناسب این عکس عرض 150 و طول 150 میباشد .',
        },
        {
          width: 100,
          height: 80,
          type: 'آپلود لوگو',
          info: 'این عکس نشان تجاری،آرم شرکت و یا مهر شرکت می تواند باشد این لوگو در صفحه اختصاصی شما نشان داده میشودو اندازه مناسب برای این عکس ارتفاع 80 و طول 100 می باشد .',
        },
        {
          width: 272,
          height: 153,
          type: 'محصول',
          info: 'این عکس محصولات قابل عرضه توسط شرکت شما میباشد اندازه مناسب برای این عکس ارتفاع 153 و طول 272 می باشد .',
        },
        {
          width: 700,
          height: 394,
          type: 'آپلود عکس پس زمینه',
          info: 'این عکس محصولات قابل عرضه توسط شرکت شما میباشد اندازه مناسب برای این عکس ارتفاع 153 و طول 272 می باشد .',
        },
        {
          width: 700,
          height: 394,
          type: 'عکس های منتخب',
          info: 'این عکس محصولات قابل عرضه توسط شرکت شما میباشد اندازه مناسب برای این عکس ارتفاع 153 و طول 272 می باشد .',
        },
      ],
      progressBarValue: 0,
      coordinates: {
        width: 0,
        height: 0,
        left: 0,
        top: 0,
      },
      imgFile: null,
      uploadLoading: false,
      openLoading: false,
      imagesFileIds: [],
      showInfoDialog: false,
      inputFileTemp: null,
      image: { src: '', type: null },
      limitations: {
        minWidth: 50,
        minHeight: 50,
      },
      result: null,

      contentDialog: false,
      imgSrc: '',
      images: [],
      cropImg: '',
      data: null,
      croppedWidth: null,
      croppedHeight: null,
      croppedSize: null,
    };
  },
  created() {
    this.imagesFileIds = this.imageFileIdsProps;
    this.images = this.imagesProps;
    if (this.cropTypeProp != null) {
      for (let index = 0; index < this.cropTypeItems.length; index++) {
        const element = this.cropTypeItems[index];
        if (element.type == this.cropTypeProp) {
          this.cropType = element;
        }
      }
    }
  },
  watch: {
    imageFileIdsProps(after, before) {
      before;
      this.imagesFileIds = after;
    },
    imagesProps(after, before) {
      this.images = after;
      before;
    },
    images(after, before) {
      this.$emit('imagesChange', after);
      before;
    },
    imagesFileIds(after, before) {
      this.$emit('imagesFileIdsChange', after);
      before;
    },
    contentDialog(after, before) {
      if (!after) {
        this.closeDialog();
      }
    },
  },
  updated() {
    if (document.getElementById('cropperId')) {
      //
      document
        .getElementById('cropperId')
        .addEventListener('wheel', this.onZoom);
      document
        .getElementById('cropperId')
        .addEventListener('click', this.onZoom);
    }
  },
  computed: {
    baseUrl() {
      return this.$store.getters.fileBaseUrl;
    },
  },
  methods: {
    onZoom() {
      if (this.$refs.cropper) {
        let canvas = this.$refs.cropper.getCroppedCanvas({
          fillColor: '#fff',
          imageSmoothingEnabled: false,
          imageSmoothingQuality: 'high',
        });
        this.getSize(canvas);
      }
    },
    getSize(canvas) {
      let app = this;
      let devision, fileSizee, message, size, unit;
      if (this.cropTypeProp != 'آپلود لوگو' && canvas) {
        this.croppedWidth = canvas.width;
        this.croppedHeight = canvas.height;
        canvas.toBlob((blob) => {
          // number.toString().length;
          if (blob.size.toString().length >= 7) {
            this.message = 'مگابایت';
            devision = 1024 * 1024;
            fileSizee = parseFloat((blob.size / devision).toFixed(2));
          } else if (blob.size.toString().length >= 4) {
            devision = 1024;
            this.message = 'کیلوبایت';
            fileSizee = parseFloat((blob.size / devision).toFixed(2));
          }
          this.croppedSize = fileSizee;
          fileSizee = parseFloat((blob.size / devision).toFixed(2));
        });
      }
    },
    zoomHandler(e) {
      if (e.detail.ratio > 1) {
        e.preventDefault();
        this.$refs.cropper.zoomTo(1);
      }
    },
    base64Convert(data, mime) {
      data = data.split(',')[1];
      data = window.atob(data);
      var ia = new Uint8Array(data.length);
      for (var i = 0; i < data.length; i++) {
        ia[i] = data.charCodeAt(i);
      }
      return new Blob([ia], {
        type: mime,
      });
    },
    sendImage(event) {
      let app = this;
      app.uploadLoading = true;
      const canvas =
        app.cropTypeProp != 'آپلود لوگو'
          ? this.$refs.cropper.getCroppedCanvas({
              fillColor: '#fff',
              imageSmoothingEnabled: false,
              imageSmoothingQuality: 'high',
            })
          : true;

      if (canvas) {
        let devision, message, size, logoSize;
        if (this.cropTypeProp == 'آپلود لوگو') {
          var blob = app.base64Convert(app.result, app.img.type);
          if (app.logoMaxFileSize.includes('M')) {
            devision = 1024 * 1024;
            message = `${app.logoMaxFileSize.slice(
              0,
              app.logoMaxFileSize.indexOf('M')
            )} مگابایت`;
            logoSize = app.logoMaxFileSize.slice(
              0,
              app.logoMaxFileSize.indexOf('M')
            );
          } else {
            devision = 1024;
            message = `${app.logoMaxFileSize.slice(
              0,
              app.logoMaxFileSize.indexOf('K')
            )} کیلوبایت`;
            logoSize = app.logoMaxFileSize.slice(
              0,
              app.logoMaxFileSize.indexOf('K')
            );
          }

          const fileSize = parseFloat(
            (app.imgFile.size / devision).toFixed(2)
            // (blob.size / devision).toFixed(2)
          );
          if (fileSize > logoSize) {
            app.closeDialog();
            Swal.fire({
              icon: 'error',
              title: 'خطا',
              html: `حجم فایل باید کمتر از ${message} باشد `,
              confirmButtonText: ' بستن',
            });
          }
          const form = new FormData();
          form.append('File', blob, app.inputFileTemp.files[0].name);
          if (!this.fileManager) {
            form.append('FolderId', 1);
            this.sendFile(form);
          } else {
            this.sendFile(form);
          }
        }
        if (this.cropTypeProp != 'آپلود لوگو') {
          canvas.toBlob((blob) => {
            if (app.maxFileSize.includes('M')) {
              devision = 1024 * 1024;
              message = `${app.maxFileSize.slice(
                0,
                app.maxFileSize.indexOf('M')
              )} مگابایت`;
              size = app.maxFileSize.slice(0, app.maxFileSize.indexOf('M'));
            } else {
              devision = 1024;
              message = `${app.maxFileSize.slice(
                0,
                app.maxFileSize.indexOf('K')
              )} کیلوبایت`;
              size = app.maxFileSize.slice(0, app.maxFileSize.indexOf('K'));
            }
            const fileSizee = parseFloat((blob.size / devision).toFixed(2));
            if (fileSizee > size) {
              app.closeDialog();

              Swal.fire({
                icon: 'error',
                title: 'خطا',
                html: `حجم فایل باید کمتر از ${message} باشد `,
                confirmButtonText: ' بستن',
              });
              app.openLoading = false;
              app.uploadLoading = false;
              return false;
            }
            const form = new FormData();
            form.append('File', blob, app.inputFileTemp.files[0].name);
            if (!this.fileManager) {
              form.append('FolderId', 1);
              this.sendFile(form);
            } else {
              this.sendFile(form);
            }
          }, app.image.type);
        }
      }
    },
    sendFile(form) {
      let app = this;
      if (this.fileManager) {
        filesRepository()
          .sendFile(
            form,
            this.baseUrl,
            { Folder: this.folder },
            {
              onUploadProgress: (progressEvent) => {
                this.progressBarValue = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
                );
              },
            }
          )
          .then((res) => {
            let jsonData = res.data;
            var obj = {
              fileId: jsonData.fileId,
              fileUrl: jsonData.links[0].href,
            };
            this.images.push(obj);
            this.imagesFileIds.push(jsonData.fileId);
            app.$dialog.message.success('با موفقیت ثبت گردید', {
              position: 'top-left',
            });
            app.closeDialog();
            this.$emit('fileUploaded');
          })
          .catch((error) => {
            Helper.handleErrors(error, this);
            app.closeDialog();
            app.result = null;
            app.image = null;
            app.uploadLoading = false;
            app.contentDialog = false;
          });
      } else {
        filesRepository()
          .sendFileWithoutFolderType(
            form,
            this.baseUrl,
            {},
            {
              onUploadProgress: (progressEvent) => {
                this.progressBarValue = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
                );
              },
            }
          )
          .then((res) => {
            let jsonData = res.data;
            var obj = {
              fileId: jsonData.fileId,
              fileUrl: jsonData.links[0].href,
            };
            this.images.push(obj);
            this.imagesFileIds.push(jsonData.fileId);
            app.$dialog.message.success('با موفقیت ثبت گردید', {
              position: 'top-left',
            });
            app.closeDialog();
            this.$emit('fileUploaded');
          })
          .catch((error) => {
            Helper.handleErrors(error, this);
            app.closeDialog();
            app.result = null;
            app.image = null;
            app.uploadLoading = false;
            app.contentDialog = false;
          });
      }
    },
    closeDialog() {
      if (this.cropTypeProp != 'آپلود لوگو') {
        this.$refs.cropper.replace(' ');
      }
      this.$refs.input.value = '';
      if (this.image && this.image.src) {
        URL.revokeObjectURL(this.image.src);
      }
      this.image = {
        src: ' ',
        type: null,
      };
      this.setImageFlag = false;
      this.imgWidth = 0;
      this.imgHeight = 0;
      this.imgFile = null;
      this.imgSrc = null;
      this.result = null;
      this.contentDialog = false;
      this.uploadLoading = false;
    },
    removeImg(item) {
      Swal.fire({
        title: 'آیا از حذف اطمینان دارید؟',
        text: 'عکس به صورت موقت پاک میشود و در صورت ذخیره فرم عکس به طور کامل پاک میشود',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'بله حذف شود!',
        cancelButtonText: 'انصراف',
      }).then((result) => {
        if (result.isConfirmed) {
          const indx = this.images.findIndex((v) => v.fileUrl === item.fileUrl);
          this.images.splice(indx, indx >= 0 ? 1 : 0);
          const indx2 = this.imagesFileIds.findIndex((v) => v == item.fileId);
          this.imagesFileIds.splice(indx2, indx2 >= 0 ? 1 : 0);
          Swal.fire('حذف شد!', 'به صورت موقت حذف شد.', 'success');
        }
      });
    },
    openImage(url) {
      window.open(url, '_blank');
    },
    cropImage() {
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      let canvas = this.$refs.cropper.getCroppedCanvas({
        fillColor: '#fff',
        imageSmoothingEnabled: false,
        imageSmoothingQuality: 'high',
      });
      this.getSize(canvas);
    },
    flipX() {
      const dom = this.$refs.flipX;
      let scale = dom.getAttribute('data-scale');
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleX(scale);
      dom.setAttribute('data-scale', scale);
    },
    flipY() {
      const dom = this.$refs.flipY;
      let scale = dom.getAttribute('data-scale');
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleY(scale);
      dom.setAttribute('data-scale', scale);
    },
    getCropBoxData() {
      this.data = JSON.stringify(this.$refs.cropper.getCropBoxData(), null, 4);
    },
    getData() {
      this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
    },
    move(offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY);
    },
    reset() {
      this.$refs.cropper.reset();
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    setCropBoxData() {
      if (!this.data) return;
      this.$refs.cropper.setCropBoxData(JSON.parse(this.data));
    },
    setData() {
      if (!this.data) return;
      this.$refs.cropper.setData(JSON.parse(this.data));
    },
    setImage(e) {
      const app = this;
      if (e.target.files.length == 0) {
        return;
      }

      app.inputFileTemp = e.target;
      const file = e.target.files[0];
      if (file.type.indexOf('image/') === -1) {
        alert('Please select an image file');
        return;
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        let img = new Image();

        const blob = URL.createObjectURL(file);
        reader.onload = (event) => {
          app.result = event.target.result;
          if (app.cropTypeProp != 'آپلود لوگو' && app.sizeCheckPermission) {
            img.onload = function () {
              app.imgWidth = this.width;
              app.imgHeight = this.height;

              app.setImageFlag = true;
              if (
                this.width < app.widthLimit ||
                this.height < app.heightLimit
              ) {
                app.result = null;
                app.image.src = '';
                img.src = '';
                app.uploadLoading = false;
                app.closeDialog();
                return Swal.fire({
                  icon: 'error',
                  title: 'خطا',
                  html: `ابعاد تصویر نباید کمتر از 394*700 باشد`,
                  confirmButtonText: ' بستن',
                });
              }
            };
          } else {
            img.onload = function () {
              //
              app.imgWidth = this.width;
              app.imgHeight = this.height;
              //
            };
            //
          }
          img.src = blob;
          this.imgSrc = blob;
          this.imgFile = file;
          app.image = {
            src: blob,
            type: getMimeType(e.target.result, file.type),
          };
          if (app.cropTypeProp != 'آپلود لوگو') {
            app.$refs.cropper.replace(blob);
            // ---------------------------------------//

            setTimeout(() => {
              let canvas = app.$refs.cropper.getCroppedCanvas({
                fillColor: '#fff',
                imageSmoothingEnabled: false,
                imageSmoothingQuality: 'high',
              });
              this.getSize(canvas);
            }, 300);

            // -------------------------------------------
          }
        };
        reader.readAsDataURL(file);
      } else {
        alert('Sorry, FileReader API not supported');
      }
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);

      let canvas = this.$refs.cropper.getCroppedCanvas({
        fillColor: '#fff',
        imageSmoothingEnabled: false,
        imageSmoothingQuality: 'high',
      });
      this.getSize(canvas);
    },
  },
};
</script>

<style scoped>
.upload-image-modal {
  z-index: 9999;
}
.content {
  display: flex;
  justify-content: space-between;
}
.cropper-area {
  width: 614px;
}

textarea {
  width: 100%;
  height: 100px;
}
.preview-area {
  width: 307px;
}
.preview-area p {
  font-size: 1.25rem;
  margin: 0;
  margin-bottom: 1rem;
}
.preview-area p:last-of-type {
  margin-top: 1rem;
}
.preview {
  direction: ltr;
  width: 100%;
  height: calc(372px * (9 / 16));
  overflow: hidden;
}
.crop-placeholder {
  width: 100%;
  height: 200px;
  background: #ccc;
}
.cropped-image img {
  max-width: 100%;
}
.cropper {
  height: 600px;
  width: 100%;
  background: #747474;
  margin: auto;
}
.square-button {
  background: rgba(black, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  width: 42px;
  margin-bottom: 10px;
  margin-left: 5px;
  margin-top: 10px;
  cursor: pointer;
  transition: background 0.5s;
}
.vertical-buttons {
  z-index: 2;
  position: absolute;
  left: 30px;
  top: 90px;
  transform: translateY(-50%);
}
.custom-item {
  position: relative;
  display: inline-block;
}
.custom-notify-badge {
  cursor: pointer;
  position: absolute;
  left: -10px;
  top: -10px;
  background: red;
  text-align: center;
  border-radius: 50%;
  border: 3px solid white;
  padding: 4px;
  font-size: 10px;
}
</style>
